// import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
// import { faGifts } from "@jewlr/pro-light-svg-icons/faGifts"
import { faTruckFast } from "@jewlr/pro-light-svg-icons/faTruckFast"
import { useSelector } from "react-redux"
// import { Link } from "react-router-dom"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
// import { showHolidayCutoff } from "helpers/holiday"

// import BridalDiscount from "./bridal-discount"
// import GiftCardPromo from "./gift-card-promo"
// import InstantGift from "./instant-gift"
// import MultiItemDiscount from "./multi-item-discount"
// import FreeGiftPromo from "./free-gift-promo"

// const StyledLink = styled(Link)`
//   color: ${(props) => props.theme.colors.primary};
//   font-size: 14px;
//   font-weight: 500;
//   letter-spacing: -0.03em;
//   line-height: 16px;
//   text-decoration: underline;
//   &:hover {
//     color: ${(props) => props.theme.colors.primary};
//     text-decoration: none;
//   }
// `

const CartPromos = () => {
  const availableHoliday = useSelector(
    (state) => state.cart.show_available_for_holiday
  )

  // const bmsmEnabled = summary.bmsm_enabled
  // const doubleJewlsPromo = summary.promo_double_jewls
  // const doubleJewlsPromoMessage = summary.promo_double_jewls_messaging

  let content = null
  // let content = <BridalDiscount />
  // let doubleJewlsContent = null
  // let giftCardPromo = false

  // const promotions = sl.config.enable_name_necklace_promo

  if (availableHoliday) {
    return (
      // <div
      //   className="text-grey-65 text-12 leading-12 tablet:mt-32 tablet:border-[#00a900] tablet:py-14 tablet:px-18 tablet:w-full desktop:w-(--desktop-width) tablet:text-left mx-auto mt-8 rounded-xl border border-[#91D78A] bg-[#DBF0CF] p-10 text-center empty:m-0 empty:border-0 empty:p-0"
      //   style={{ "--desktop-width": "740px" }}
      // >
      <div className="bg-primary tablet:py-12 text-14 tablet:text-15 leading-14 tablet:gap-10 tablet:mt-32 mb-30 tablet:mb-0 flex items-center justify-center gap-8 px-8 py-10 font-bold uppercase text-white">
        <FontAwesomeIcon className="text-24" icon={faTruckFast} />
        {/* <Image
            alt="Holiday Delivery"
            height="15px"
            src={require("images/cart/promos/fast-shipping.svg")}
            width="26px"
          /> */}
        <p className="tablet:hidden">
          Order Now for{" "}
          {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}{" "}
          Delivery!
        </p>
        <p className="tablet:block hidden">
          Order Now for Guaranteed{" "}
          {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}{" "}
          Delivery!
        </p>
      </div>
    )
  }
  // if (showHolidayCutoff) {
  //   content = <InstantGift />
  // } else if (sl.config.gift_card_promo.enable) {
  //   if (amountNeeded > 0) {
  //     giftCardPromo = true
  //   }

  //   content = <GiftCardPromo />
  // if (sl.config.multi_item_discount) {
  //   if (bmsmEnabled) content = <MultiItemDiscount refs={refs} />
  //   else {
  //     content = null
  //   }
  // }
  // if (doubleJewlsPromo) {
  //   doubleJewlsContent = (
  //     <>
  //       <FontAwesomeIcon fontSize="18px" icon={faGem} />
  //       <Typography fontSize="16px" fontWeight="700">
  //         {doubleJewlsPromoMessage}
  //       </Typography>
  //     </>
  //   )
  // }

  if (!content) return null

  return (
    <>
      {/* <ExtraSavingContainer
        doubleJewlsPromo={doubleJewlsPromo}
        giftCardPromo={giftCardPromo}
      >
        {content}
        {doubleJewlsPromo && (
          <MediaFlex
            alignItems="center"
            flexGrow="1"
            gap="6px"
            greaterThanOrEqual="tablet"
            justifyContent="center"
            mt="12px"
          >
            {doubleJewlsContent}
          </MediaFlex>
        )}
      </ExtraSavingContainer> */}
      {/* {doubleJewlsPromo && (
        <ExtraSavingContainer
          alignItems="center"
          as={MediaBox}
          gap="6px"
          lessThan="tablet"
        >
          {doubleJewlsContent}
        </ExtraSavingContainer>
      )}
      {promotions && summary.promotion_discount >= 0 && (
        <ExtraSavingContainer
          as={MediaBox}
          lessThan="tablet"
          textAlign="center"
        >
          <Flex
            alignItems="center"
            flexGrow="1"
            gap="6px"
            justifyContent="center"
            mb="4px"
          >
            <FontAwesomeIcon
              color={{ _: "greenDarker", tablet: "black" }}
              fontSize="18px"
              icon={faGifts}
            />
            <Typography
              color={{ _: "greenDarker", tablet: "black" }}
              fontSize="16px"
              fontWeight="700"
              lineHeight="18px"
              textAlign="left"
            >
              Buy any 2+ Name Necklaces
            </Typography>
          </Flex>
          <Flex alignItems="baseline" gap="6px" justifyContent="center">
            <Typography
              fontSize="14px"
              fontWeight="500"
              letterSpacing="-0.03em"
              lineHeight="16px"
            >
              Save an extra 15% on each
            </Typography>
            <StyledLink data-lc="promos" to="/all-name-initial-necklaces">
              Shop Name Necklaces
            </StyledLink>
          </Flex>
        </ExtraSavingContainer>
      )} */}
    </>
  )
}

export default CartPromos
